import React from 'react';
import Map from './Map';
import Crossword from '@jaredreisinger/react-crossword';
import './App.css'
import './style.css'



const App = () => {

  return (
    <div>
      <Map />
    </div>
  );
};

export default App;
